/**
 * Asynchronously loads the component for PhotoVoting
 */

import React from 'react';
import dynamic from 'next/dynamic';
import LoadingDefault from '~/components/LoadingDefault';

export default dynamic(() => import('./index'), {
  loading: () => <LoadingDefault />,
  ssr: false,
});
